"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadAdAttributionView = void 0;
function parseILeadAdAttributionView(data) {
    if (typeof data.captured_at === 'string')
        data.captured_at = new Date(data.captured_at);
    if (typeof data.network_data_purged_at === 'string')
        data.network_data_purged_at = new Date(data.network_data_purged_at);
    return data;
}
exports.parseILeadAdAttributionView = parseILeadAdAttributionView;
